module.exports = __webpack_public_path__ + "static/media/simon-game.7e7a9960.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/simon-game.png
// module id = 70
// module chunks = 0